export default {
  agendaTitle: "AGENDA_TITLE",
  agendaMonth: "AGENDA_MONTH",
  agendaWeek: "AGENDA_WEEK",
  agendaAll: 'AGENDA_ALL',
  agendaAppointment: "AGENDA_APPOINTMENT",
  agendaEvent: "AGENDA_EVENT",
  agendaStart: "AGENDA_START",
  agendaEnd: "AGENDA_END",
  agendaTicket: "AGENDA_TICKET",
  agendaBlock: "AGENDA_BLOCK",
  agendaIndependentContractor: "AGENDA_INDEPENDENT_CONTRACTOR",
  agendaIndependentContractorUpdate: "AGENDA_INDEPENDENT_CONTRACTOR_UPDATE",
  agendaParticipant: "AGENDA_PARTICIPANT",
  agendaWelcoming: "AGENDA_WELCOMING",
  agendaTitlePlaceholder: "AGENDA_PLACEHOLDER",
  agendaRedirectTo: "AGENDA_REDIRECTTO",
  agendaName: "AGENDA_NAME",
  agendaSidebarBlock: "AGENDA_SIDEBAR_BLOCK",
  agendaSidebarIndependentContractor: "AGENDA_SIDEBAR_INDEPENDENT_CONTRACTOR",
  agendaModalTitle: 'AGENDA_MODAL_TITLE',
  agendaModalTitleEventModification: 'AGENDA_MODAL_TITLE_EVENT_MODIFICATION',
  agendaAppointmentWithoutTicket: 'AGENDA_APPOINTMENT_WITHOUT_TICKET'
}



// WEBPACK FOOTER //
// ./src/locales/agenda/index.ts